import React from 'react';

const Logo = ({ className }) => {
    return (
        <span className={`${className} tracking-wider pb-4`}>
            WARDROBE
        </span>
    );
};

export default Logo;